import { MAX_NAME_LENGTH } from 'constants/chat';
import initialState from './initialState';

export const getToken = ({ session }) => session.token;

export const getApiUrlDomain = ({ session }) => session.apiUrlDomain;

export const getChatConfig = ({ session }) => session.config;

export const getIsPreviewMode = ({ session }) =>
  Boolean(session.config.previewMode);

export const getIsRestartEnabled = ({ session }) =>
  session.config.enableResetButton;

export const getPersistentChatData = ({ session }) => session.persistentData;

export const getIsDataPersistent = ({ session }) =>
  session.config.dataPersistent;

export const getWelcomeForm = ({ session }) => session.config.welcomeForm;

export const getGoogleAnalyticsEnabled = ({ session }) => session.config.ga;

export const getChatTitle = ({ session }) => session.config.title;

export const getChatSubtitle = ({ session }) => session.config.subtitle;

export const getFont = ({ session }) => session.config.font;

export const getBackgroundColor = ({ session }) =>
  session.config.backgroundColor;

export const getFooter = ({ session }) => session.config.footer;

export const getTranscriptDownload = ({ session }) =>
  session.config.enableTranscriptDownload;

export const getIsDisabledSecuredStyles = ({ session }) =>
  session.config.disableSecuredStyles;

export const getFeedback = ({ session }) => session.config.feedback;

export const getNotificationsConfig = ({ session }) => ({
  ...initialState.config.notifications,
  ...session.config.notifications,
});

const getResponderData = (initData, currentData) => {
  const data = {
    ...initData,
    ...currentData,
  };

  return {
    ...data,
    name: data.name.substring(0, MAX_NAME_LENGTH),
  };
};

export const getAgentData = ({ session }) =>
  getResponderData(initialState.config.agent, session.config.agent);

export const getBotData = ({ session }) =>
  getResponderData(initialState.config.bot, session.config.bot);

export const getReopenMinimizedChat = ({ session }) =>
  session.config.shouldReopenMinimizedChat;

export const getLocale = ({ session }) => session.config.locale;

export const getEnableTransferDisableInput = ({ session }) =>
  session.config.enableTransferDisableInput !== false;

export const getEnableSensitiveInputMask = ({ session }) =>
  Boolean(session.config.enableSensitiveInputMask);
